import { useSelector } from "react-redux";
import {
  HomeColorIcon,
  HomeIcon,
  MessageColorIcon,
  MessageIcon,
  NewsfeedColoricon,
  NewsfeedIcon,
} from "../../../components/ui-elements/svg-icons";
import {
  PATH_DASHBOARD,
  PATH_MESSAGES,
  PATH_NEWSFEED,
} from "../../../routes/path";
import { RootState } from "../../../store/store";

const NavConfig = () => {
  const onboarded = useSelector((state: RootState) => state.content.onboarded);
  const verified = useSelector((state: RootState) => state.content.verified);
  const content = [
    {
      title: "Home",
      path: PATH_DASHBOARD.root,
      icon: <HomeIcon />,
      colorIcon: <HomeColorIcon />,
    },
    {
      title: "Messages",
      path: PATH_MESSAGES.root,
      icon: <MessageIcon />,
      colorIcon: <MessageColorIcon />,
    },
    {
      title: "Newsfeed",
      path: PATH_NEWSFEED.root,
      icon: <NewsfeedIcon />,
      colorIcon: <NewsfeedColoricon />,
    },
  ];

  return content;
};

export default NavConfig;
